import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GLOBAL_API_BASE_URL } from '@chk/env-variables';
import { getGlobalAPIHeaders } from '@data/global-api-common';
import { asyncFetch, validateSchema } from '@utility/checkout-utils';

import { GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS } from '../../constants/endpoints';
import { ACCOUNT_ACCESS_TAGS } from '../../constants/tags';
import { GlobalApiAccountAccessSchema } from '../../schemas/GlobalApiAccountAccess';

import type {
  PatchGlobalApiAccountAccessBody,
  PatchGlobalApiAccountAccessParams,
} from './usePatchGlobalApiAccountAccess.types';

export const usePatchGlobalApiAccountAccess = ({
  accountAccessId,
  authToken,
  voltApp,
}: PatchGlobalApiAccountAccessParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PatchGlobalApiAccountAccessBody) =>
      asyncFetch(
        `${GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS.patch(accountAccessId)}`,
        {
          body: JSON.stringify(body),
          method: 'PATCH',
          headers: getGlobalAPIHeaders({
            authToken,
            voltApp,
            voltService: 'ais',
          }),
        },
        GLOBAL_API_BASE_URL,
        true
      ).then(validateSchema(GlobalApiAccountAccessSchema)),
    onSuccess: (data) => {
      queryClient.setQueryData(
        ACCOUNT_ACCESS_TAGS.GLOBAL_API(accountAccessId),
        data
      );
    },
  });
};
